import {getLibraryTransferUrl} from '@lib/getLibraryTransferUrl';
import {legacyApiCall} from '@modules/legacyApi';
import {useUser} from '@providers/UserProvider';

const useTmmRedirect = () => {
	const {user} = useUser();
	return async (
		redirectUrl: string,
		campaign: string,
	): Promise<string | null> => {
		const userId = user?.id;
		const name = user?.name;

		if (!userId || !name) {
			throw new Error('Error user');
		}

		const token = await legacyApiCall({
			method: 'libraryimport.getTMMAccessToken',
			data: {},
		});

		if (!token) {
			throw new Error('Error token');
		}

		const migrationUrl = await getLibraryTransferUrl(
			userId,
			name,
			token as string,
			redirectUrl,
			campaign,
		);

		if (!migrationUrl) {
			throw new Error('Error migrationUrl');
		}

		return migrationUrl;
	};
};

export default useTmmRedirect;
